import { render, staticRenderFns } from "./ProductPriceChartModal.vue?vue&type=template&id=657f5e94&scoped=true"
import script from "./ProductPriceChartModal.vue?vue&type=script&lang=js"
export * from "./ProductPriceChartModal.vue?vue&type=script&lang=js"
import style0 from "./ProductPriceChartModal.vue?vue&type=style&index=0&id=657f5e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657f5e94",
  null
  
)

export default component.exports